import React, { Dispatch, SetStateAction, useCallback, useEffect, useMemo, useState } from 'react'
import { Table, Input, PaginationItem, PaginationLink, Pagination, Row, Col, Label } from "reactstrap"
import { DetalleActividadHorasExtras, DetalleGrupoActividades, PutActividadHoraExtra, PutGrupoActividadHoraExtra } from '../TypesParametrosHorasExtras';
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';

import { ReactComponent as EditarSVG } from "../../../../../assets/icons/editar.svg";
import { SelectCombo } from 'components/Types/GeneralTypes';
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';
import { ActualizarGrupoActividadHoraExtra } from '../FunctionsParametrosHE';


import ReactSwitch from 'react-switch';
import { showAlert } from '../Actividades/ActividadesHorasExtras';


type PropsTableGruposActividadesHE = {
    gruposActividadesHorasExtras: DetalleGrupoActividades[],
    opcionesEstado: SelectCombo[],
    cargarGrupos: () => Promise<void>
}

export default function TableGruposActividadesHorasExtras(props: PropsTableGruposActividadesHE) {

    const { gruposActividadesHorasExtras } = props;



    const [observations, setObservations] = useState<Record<number, string[]>>({});

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');

    const [sortColumn, setSortColumn] = useState<string | null>(null);
    const [sortDirection, setSortDirection] = useState('asc');
    const [sortToggle, setSortToggle] = useState(false);

    const [filterStatus, setFilterStatus] = useState('A'); // '' will show all rows by default


    const [actividadEditando, setactividadEditando] = useState<DetalleGrupoActividades | undefined>(undefined)
    const [actividadHabilitando, setactividadHabilitando] = useState<DetalleGrupoActividades | undefined>(undefined)
    const [estadoActividad, setestadoActividad] = useState<string | undefined>(undefined)
    //States Modal Actualizando
    const [textoActividad, settextoActividad] = useState<string>("")




    const filteredServidores = gruposActividadesHorasExtras.filter(actv =>
       ( actv.nombreGrupo.toLowerCase().includes(searchTerm.toLowerCase()) ||
        actv.estado.toLowerCase().includes(searchTerm.toLowerCase()) ||
        actv.usuario.toLowerCase().includes(searchTerm.toLowerCase())) &&
        actv.estado.trim().toLowerCase() === filterStatus.trim().toLocaleLowerCase()


    );

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    let currentRows = filteredServidores.slice(indexOfFirstRow, indexOfLastRow);

    const pageNumbers: number[] = [];
    for (let i = 1; i <= Math.ceil(filteredServidores.length / rowsPerPage); i++) {
        pageNumbers.push(i);
    }

    const renderPageNumbers = pageNumbers.map(number => (
        <PaginationItem key={number} active={number === currentPage}>
            <PaginationLink onClick={() => setCurrentPage(number)}>
                {number}
            </PaginationLink>
        </PaginationItem>
    ));

    useEffect(() => {
        // Cargar los valores del localStorage cuando se monta el componente
        const savedRowsPerPage = localStorage.getItem('rowsPerPageGrupo');
        const savedSortColumn = localStorage.getItem('sortColumnGrupo');
        const savedSortDirection = localStorage.getItem('sortDirectionGrupo');
    
        if (savedRowsPerPage) {
            setRowsPerPage(parseInt(savedRowsPerPage, 10));
        }
        if (savedSortColumn) {
            setSortColumn(savedSortColumn);
        }
        if (savedSortDirection) {
            setSortDirection(savedSortDirection);
        }
    }, []);

    const handleSort = (column: string) => {
        const isAsc = sortColumn === column && sortDirection === 'asc';
        const newSortDirection = isAsc ? 'desc' : 'asc';

        setSortColumn(column);
        setSortDirection(isAsc ? 'desc' : 'asc');
        setSortToggle(!sortToggle); // Cambia el estado para forzar re-render
        
        localStorage.setItem('sortColumnGrupo', column);
        localStorage.setItem('sortDirectionGrupo', newSortDirection);
    };


    const applySorting = (data: DetalleGrupoActividades[]) => {
        if (!sortColumn) return data;

        if (sortColumn !== null && data !== null) {
            const sortedData = [...data].sort((a, b) => {
                const valA = a[sortColumn];
                const valB = b[sortColumn];
                return (valA < valB ? -1 : 1) * (sortDirection === 'asc' ? 1 : -1);
            });
            return sortedData;
        }

        return data;

    };

    const sortedActividades = applySorting(filteredServidores);
    currentRows = sortedActividades.slice(indexOfFirstRow, indexOfLastRow);




    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reiniciar la paginación cuando se busca
    };

    const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(selectedRowsPerPage);
        setCurrentPage(1); // Reiniciar a la primera página al cambiar el número de filas por página
    
        localStorage.setItem('rowsPerPageGrupo', selectedRowsPerPage.toString()); 
    };


    const handleChangeSelect = (setter: Dispatch<SetStateAction<string>>) => (value: string) => {
        setter((value));
    };

    const handleFilterStatusChange = (e) => {
        setFilterStatus(e.target.value);
    };

    const ActualizarGrupoActividad = useCallback(
        async (putActividad: DetalleGrupoActividades | undefined) => {

            if (putActividad === undefined) {
                return -1
            }

            const copiaActividad: PutGrupoActividadHoraExtra = {
                grupo: textoActividad,
                estado: putActividad.estado,
                idGrupoActividad: putActividad.idGrupo
            }

            // var copiaActividad: PutGrupoActividadHoraExtra = { ...putActividad }

            // copiaActividad.grupo = textoActividad;

            const respuesta = await ActualizarGrupoActividadHoraExtra(copiaActividad)
            if (respuesta.status === 200) {
                showAlert("Se ha actualizado el grupo", true)
                props.cargarGrupos()
                return 1

            }
            else {
                showAlert(respuesta.errorMessage ?? "Ha ocurrido un inconveniente", false);
                return -1
            }
        },
        [textoActividad, estadoActividad],
    )

    const HabilitarActividad = useCallback(
        async () => {
            if (actividadHabilitando && estadoActividad) {
                const actividadActualizar: PutGrupoActividadHoraExtra = {
                    grupo: actividadHabilitando.nombreGrupo,
                    estado: estadoActividad,
                    idGrupoActividad: actividadHabilitando.idGrupo
                }

                const respuesta = await ActualizarGrupoActividadHoraExtra(actividadActualizar)
                if (respuesta.status === 200) {
                    const mensajeEstado = estadoActividad === "A" ? "habilitado" : "inhabilitado";
                    showAlert(`Se ha ${mensajeEstado} el grupo`, true)
                    props.cargarGrupos()
                    return 1

                }
                else {
                    showAlert(respuesta.errorMessage ?? "Ha ocurrido un inconveniente", false);
                    return -1
                }
            }
            else {
                showAlert("Debe seleccionar un grupo para activar/inactivar", false);

            }

            return -1
        }, [actividadHabilitando, estadoActividad])



    useEffect(() => {
        if (actividadEditando !== undefined) {
            settextoActividad(actividadEditando.nombreGrupo);
            setestadoActividad(actividadEditando.estado)
        }
    }, [actividadEditando])


    const contenidoModalActualizarActividad = useMemo(
        () => {
            if (actividadEditando) {
                return (
                    <React.Fragment>
                        <Row>
                            <Col xl={12}>
                                <Row>

                                    <Col xl={12}>
                                        <span className={"labelParametrosHE"}> Grupo</span>

                                    </Col>
                                    <Col xl={12}>
                                        <Input className="font-modal-he2" type="text" value={textoActividad} onChange={(e) => {

                                            var texto = e.target.value;
                                            if (texto) {
                                                texto = texto.toUpperCase()
                                            }
                                            settextoActividad(texto)
                                        }}>
                                        </Input>
                                    </Col>

                                </Row>
                            </Col>

                        </Row>

                    </React.Fragment>

                )
            }
            else if (actividadHabilitando && estadoActividad) {


                const mensajeEstado = estadoActividad === "A" ? "habilitar" : "inhabilitar";

                return (
                    <React.Fragment>
                        <Row>
                            <Col xl={12}>
                                <Row>
                                    <Col xl={12}>
                                        <div className="font-modal-he2">
                                            ¿Desea <span><strong>{mensajeEstado}</strong> el siguiente grupo?</span>
                                        </div>
                                    </Col>

                                </Row>
                                <Row>
                                    <Col xl={12}>
                                        <div className="mt-3 font-modal-he">{actividadHabilitando.nombreGrupo}</div>
                                    </Col>

                                </Row>
                            </Col>

                        </Row>

                    </React.Fragment>

                )
            }
            else {
                return (
                    <div> No se ha seleccionado actividad para editar </div>
                )
            }
        },
        [actividadEditando, actividadHabilitando, textoActividad, estadoActividad],
    )

    function OnPressSwitchActividad(actividadHabilitando: DetalleGrupoActividades) {
        setactividadHabilitando(actividadHabilitando)
        const nuevoEstado: string = actividadHabilitando.estado === "A" ? "I" : "A"
        setestadoActividad(nuevoEstado)
    }



    return (
        <React.Fragment>
            <Row className="mb-1 mt-1">
                <Col md="5" className="d-flex flex-column align-self-end justify-content-start">
                    <Label for="select" className="mb-1 labelParametrosHE">Estado</Label>
                    <Input
                        type="select"
                        placeholder="Estado"
                        value={filterStatus}
                        onChange={handleFilterStatusChange}
                        className="form-control-sm" // Reduce el tamaño del input
                    >
                        {
                            props.opcionesEstado.map((v, i) => {
                                return (
                                    <option key={"opcionEstadoGHE " + i} value={v.value.trim()}>{v.label}</option>
                                )
                            })
                        }
                    </Input>
                </Col>
            </Row>
            <Row className="mb-2 mt-2">
                <Col md="9">
                    <div className="d-flex align-items-center justify-content-start">
                        <Label for="rowsPerPageSelect" className="mb-0 mr-2">Mostrar</Label>
                        <select
                            id="rowsPerPageSelect"
                            value={rowsPerPage}
                            onChange={handleRowsPerPageChange}
                            className="custom-select custom-select-sm mr-2" // Ajusta el tamaño del select
                            style={{ width: 'auto' }} // Asegura que el select no tome más espacio del necesario
                        >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                        </select>
                        <Label className="mb-0">filas</Label>
                    </div>
                </Col>
                    <Col md="3">
                        <Input
                            type="text"
                            placeholder="Buscar..."
                            value={searchTerm}
                            onChange={handleSearchChange}
                            className="form-control-sm" // Reduce el tamaño del input
                        />
                    </Col>

            </Row>
            <Table responsive bordered className="table_planificacion_he">
                <thead className="cabeceras_tabla_planificacion_he">
                    <tr className="borde_cabeceras_he">
                        <th colSpan={1} onClick={() => handleSort('nombreGrupo')}>Grupo</th>
                        <th colSpan={1} onClick={() => handleSort('estadoParse')}>Estado</th>
                        <th colSpan={1} onClick={() => handleSort('usuario')}>Usuario</th>
                        <th colSpan={1} onClick={() => handleSort('ultimoCambio')}>F. último cambio</th>

                        <th colSpan={1}>Acciones</th>
                    </tr>
                </thead>
                {currentRows.map((serv, idServ) => {
                    return (
                        <React.Fragment key={idServ}>
                            <tbody>
                                <tr className='rows_tabla_planificacion_he'>
                                    <td className=''>
                                        <div style={{ textAlign: "left", paddingLeft: "10px" }}>
                                            {serv.nombreGrupo}
                                        </div>

                                    </td>
                                    <td className='centrado'>{serv.estadoParse}</td>
                                    <td className='centrado'>{serv.usuario}</td>


                                    <td className='centrado'>{ObtenerFechaFromIsoFormat(serv.ultimoCambio.toString())}</td>

                                    <td>
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "5px" }}>

                                            <EditarSVG
                                                className="iconEditarActividadHE"
                                                onClick={() => setactividadEditando(serv)}
                                            />

                                            <ReactSwitch
                                                onChange={() => OnPressSwitchActividad(serv)}
                                                checked={serv.estado === "A"}
                                                offColor="#FFFFFF"
                                                onColor="#243165"
                                                offHandleColor="#243165"
                                                uncheckedIcon={false}
                                                checkedIcon={false}
                                                height={20}
                                                width={30}
                                                className={"custom-switch-actividadHE"}
                                            />


                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </React.Fragment>
                    )



                })}
            </Table>
            <Pagination size="sm" className="pagination_planificacion_he">
                {renderPageNumbers}
            </Pagination>


            <ModalConfirmacion
                idModal="ModalEditarActividadHE"

                show={actividadEditando !== undefined}
                size='lg'
                centered={true}
                asyncAccion={true}
                asyncClose={false}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                // nam
                mensajeConfirmacion=''
                nombreBotonAccion='Actualizar'
                nombreBotonCerrarModal='Cancelar'
                classNameBotonAccion='btnConfirmarHabActHE'
                classNameBotonCerrarModal2='btnCancelarHabActHE'
                onClose={() => setactividadEditando(undefined)}
                asyncOnClick={() => ActualizarGrupoActividad(actividadEditando)}
                contentModal={contenidoModalActualizarActividad}
                tituloModal='Editar grupo'
            />


            <ModalConfirmacion
                idModal="ModalHabilitarActividadHE"
                show={actividadHabilitando !== undefined && estadoActividad !== undefined}
                size='md'
                centered={true}
                asyncAccion={true}
                asyncClose={false}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                // nam
                mensajeConfirmacion=''
                nombreBotonAccion='Confirmar'
                nombreBotonCerrarModal='Cancelar'
                onClose={() => { setactividadHabilitando(undefined); setestadoActividad(undefined) }}
                asyncOnClick={() => HabilitarActividad()}
                contentModal={contenidoModalActualizarActividad}
                classNameContentModal=''
                tituloModal=''
                noModalHeader={true}
                classNameBotonAccion='btnConfirmarHabActHE'
                classNameBotonCerrarModal2='btnCancelarHabActHE'
            />

        </React.Fragment>

    )
}
